import { Pipe, PipeTransform } from '@angular/core';
import { EquipmentToShow } from '@/interfaces/new-license-request/new-license-request-interfaces';
@Pipe({
  name: 'separatedByCharacter',
})
export class SeparatedByCharacterPipe implements PipeTransform {

  transform(input: EquipmentToShow[] | string[], separator: Array<string>): string {
    if (separator.length > 1) {
      if (input.length > 2) {
        return input.join(separator[0]);   
      }
      return input.join(separator[1]);
    }
    return input.join(separator[0]);
  }
}
